import { render, staticRenderFns } from "./MoreComments.vue?vue&type=template&id=b2227000&scoped=true&"
import script from "./MoreComments.vue?vue&type=script&lang=js&"
export * from "./MoreComments.vue?vue&type=script&lang=js&"
import style0 from "./MoreComments.vue?vue&type=style&index=0&id=b2227000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2227000",
  null
  
)

export default component.exports